<template>
  <FilterComponent
    :title="'Filtros Modelos'"
    :open="openFilter"
    :fields="filterFields"
    @apply-filters="handleFilters"
    @update-open="openFilter = false"
  />

  <ModelosPropostaForm
    v-if="newOpen"
    title="Novo Modelo de Proposta"
    :open="newOpen"
    :placeHolderValues="{}"
    :isEdit="false"
    @data="onSendFormData"
    @update-open="newOpen = false"
  />

  <ModelosPropostaForm
    v-if="editOpen"
    title="Editar Modelo de Proposta"
    :open="editOpen"
    :placeHolderValues="editFormData"
    :isEdit="true"
    @editing-data="onSendEditingData"
    @update-open="editOpen = false"
  />

  <Commonlisting
    :listingData="data"
    :headersData="headers"
    :headerInfo="headerInfo"
    :previous="previous"
    :next="next"
    :inputsListing="inputs"
    :currentPage="currentPage"
    :totalPages="totalPages"
    :totalRecords="totalRecords"
    :resetFormData="resetFormData"
    :editFormData="editFormData"
    :importFile="false"
    :useForms="false"
    :fileOnly="false"
    @previous-page="pageData"
    @next-page="pageData"
    @go-to-page="goTo"
    @find-by-field="filtered"
    @clean-filter="cleanFilter"
    @send-form-data="onSendFormData"
    @delete-data-id="deleteData"
    @edit-alternative="getEditData"
    @new-alternative="newEntry"
    @view-confirmation="getEditData"
    @filter="openFilter = true"
    :customActions="customActions"
    @acao-customizada="handleCustomAction"
  />

  <!-- Loading element -->
  <CommonLoading v-if="loading" />
</template>

<script>
import Commonlisting from '@/components/generalcomponents/CommonListing';
import ModeloPropostaRepository from '@/services/ModeloPropostaRepository.vue';
import { pageVariables } from '@/views/insideviews/modelo_proposta/PageVariablesModelosProposta';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import Swal from "sweetalert2";
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import ModelosPropostaForm from './ModelosPropostaForm.vue';

export default {
  name: 'ModelosPropostaView',
  components: {
    Commonlisting,
    FilterComponent,
    CommonLoading,
    ModelosPropostaForm
  },
  async created() {
    this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
    this.pageData(this.modeloFilterPage);
  },
  data() {
    return {
      ...pageVariables,
      data: [],
      previous: '',
      next: '',
      totalPages: 0,
      totalRecords: 0,
      currentPage: 1,
      resetFormData: false,
      editFormData: {},
      error: '',
      onlineUser: {},
      editOpen: false,
      newOpen: false,
      openFilter: false,
      hasFilterAplied: false,
      modeloFilterPage: { "page": 1, "query": "", "perpage": 10 },
      loading: false,
    };
  },
  methods: {
    async pageData(filter) {
      this.loading = true;
      this.modeloFilterPage = filter;
      const repo = new ModeloPropostaRepository();
      try {
        let queryString = `page=${filter.page}&per_page=${filter.perpage}`;
        if (filter.query) {
          queryString += `&search=${filter.query}`;
        }
        
        const response = await repo.getModelosQuery(this.onlineUser.token, queryString);
        if (response?.status === 200) {
          this.data = response.data; // Adapte caso o backend use Paginator
          this.previous = ""; 
          this.next = ""; 
          this.totalPages = 1; 
          this.totalRecords = this.data.length; 
          this.currentPage = filter.page;
        } else {
          this.error = response?.message;
        }
      } catch (error) {
        handleUnauthorized(error);
      } finally {
        this.loading = false;
      }
    },
    newEntry() {
      this.resetFormData = true;
      this.newOpen = true;
      setTimeout(() => {
        this.resetFormData = false;
      }, 100);
    },
    async getEditData(id) {
      if (!id) return;
      this.loading = true;
      const repo = new ModeloPropostaRepository();
      try {
        const response = await repo.getModeloById(this.onlineUser.token, id);
        if (response?.status === 200) {
          this.editFormData = response.data;
          this.editOpen = true;
        } else {
          Swal.fire('Erro!', 'Registro não encontrado.', 'error');
        }
      } catch (error) {
        handleUnauthorized(error);
      } finally {
        this.loading = false;
      }
    },
    async onSendFormData(data) {
      this.loading = true;
      const repo = new ModeloPropostaRepository();
      try {
        // Formata os dados para o endpoint e fecha popup
        this.newOpen = false;
        const response = await repo.createModelo(this.onlineUser.token, data);
        if (response?.status === 201 || response?.status === 200) {
          Swal.fire('Sucesso!', 'Registro criado/atualizado com sucesso.', 'success');
          this.pageData(this.modeloFilterPage);
        } else {
          Swal.fire('Aviso', response.data?.mensagem || 'Erro ao processar chamada', 'warning');
        }
      } catch (error) {
        if(error?.response?.status === 422) {
           let msg = error.response.data?.mensagem || 'Conflito de variáveis';
           if(error.response.data?.chaves_invalidas) {
               msg += '. Invalidas: ' + error.response.data.chaves_invalidas.join(', ');
           }
           Swal.fire('Conflito', msg, 'error');
           this.newOpen = true; // reopen to let user fix
        } else {
           handleUnauthorized(error);
        }
      } finally {
        this.loading = false;
      }
    },
    async onSendEditingData(data, id) {
      this.loading = true;
      const repo = new ModeloPropostaRepository();
      try {
        this.editOpen = false;
        const response = await repo.editModelo(this.onlineUser.token, id, data);
        if (response?.status === 200) {
          Swal.fire('Sucesso!', 'Registro Atualizado com sucesso.', 'success');
          this.pageData(this.modeloFilterPage);
        } else {
          Swal.fire('Erro!', 'Não foi possível atualizar.', 'error');
        }
      } catch (error) {
         if(error?.response?.status === 422) {
           let msg = error.response.data?.mensagem || 'Conflito de variáveis';
           if(error.response.data?.chaves_invalidas) {
               msg += '. Invalidas: ' + error.response.data.chaves_invalidas.join(', ');
           }
           Swal.fire('Conflito', msg, 'error');
           this.editOpen = true;
        } else {
           handleUnauthorized(error);
        }
      } finally {
        this.loading = false;
      }
    },
    async deleteData(id) {
      const result = await Swal.fire({
        title: 'Você tem certeza?',
        text: "Desativar este Modelo de Proposta?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, inativar!'
      });
      if (result.isConfirmed) {
        this.loading = true;
        const repo = new ModeloPropostaRepository();
        try {
          const response = await repo.toggleStatus(this.onlineUser.token, id, false);
          if (response?.status === 200) {
            Swal.fire('Inativado!', 'Modelo foi inativado com sucesso.', 'success');
            this.pageData(this.modeloFilterPage);
          } else {
            Swal.fire('Erro!', 'Não inativado.', 'error');
          }
        } catch (error) {
          handleUnauthorized(error);
        } finally {
          this.loading = false;
        }
      }
    },
    goTo(page) {
      this.modeloFilterPage.page = page;
      this.pageData(this.modeloFilterPage);
    },
    handleFilters(appliedFilters) {
      let q = [];
      // Monta query genérica caso tenham digitado no campo modelo
      if (appliedFilters.nome_modelo) {
        q.push(appliedFilters.nome_modelo);
      }
      this.modeloFilterPage.query = q.join(" ");
      this.modeloFilterPage.page = 1;
      this.hasFilterAplied = true;
      this.pageData(this.modeloFilterPage);
    },
    filtered(payload) {
      this.modeloFilterPage.query = payload.query;
      this.modeloFilterPage.page = 1;
      this.pageData(this.modeloFilterPage);
    },
    cleanFilter() {
      this.hasFilterAplied = false;
      this.modeloFilterPage.query = "";
      this.modeloFilterPage.page = 1;
      this.pageData(this.modeloFilterPage);
    },
    async handleCustomAction(action) {
      if (action === 'baixaPreview') {
        Swal.fire('Info', 'A rota de preview do histórico completo pode ser montada.', 'info');
      }
    }
  }
};
</script>
